/* eslint-disable react-hooks/exhaustive-deps */
import { Locale } from "@common/constans";
import { IEvent, IMedia } from "@common/models/CMS";
import { Culture } from "@core/Culture";
import Translate from "@service/Translate";
import { FC, useEffect, useRef, useState } from "react";
import Icon from "./general/Icon";
import OptimizedImage from "./general/OptimizedImage";

interface IUpcomingEvent {
    season?: string;
    events?: IEvent[];
}

interface IContent {
    descriptions: IUpcomingEvent[];
    images: IMedia[];
}

interface IUpcomingEventProps {
    dataSource: IEvent[];
}

let activeSlideIndex: number = 0;
let activeSlideHeight: number = 0;
let scroll = 0;
const UpcomingEvent: FC<IUpcomingEventProps> = ({ dataSource }) => {
    const { tr } = Translate;
    const { code, months } = Culture.getLocale();
    const scrollIndex = useRef<number>();
    const [activeSlideNumber, setActiveSlideNumber] = useState<number>(1);
    const [content, setContent] = useState<IContent>({ descriptions: [], images: [] });
    const season = ['Spring', 'Summer', 'Autumn', 'Winter'];
    const localeSeason = ['بهار', 'تابستان', 'پاییز', 'زمستان'];
    const seasonsOrder = code === Locale.fa ? localeSeason : season;
    let itemIndex = 0;

    useEffect(() => {
        seasonsOrder.forEach(season => {
            const events = dataSource.filter(event => months.find((m,index) => index === Culture.getDateTimeInstance().setTime(new Date(event.startTime || 0).getTime()).getMonth())?.season === season);
            content.descriptions.push({
                events,
                season: season
            })
        })
        content.descriptions.forEach((description, index) => {
            const sortEvents = description.events?.sort((a, b) => (new Date(a.startTime || 0).getTime()) - (new Date(b.startTime || 0).getTime()));
            content.descriptions[index].events = sortEvents;
            sortEvents?.forEach(e => content.images.push(e.cover || { paths: [], texts: [] }));
        });
        setContent({ ...content });
        setTimeout(() => {
            const sliderItems = document.getElementsByClassName('itinerary-slider-content-item') as HTMLCollectionOf<HTMLElement>;
            for (const key in sliderItems) {
                if (Object.prototype.hasOwnProperty.call(sliderItems, key)) {
                    const element = sliderItems[key];
                    element.style.height = `${element.getBoundingClientRect().height}px`;
                }
            }
        }, 500);
    }, []);

    useEffect(() => {
        document.addEventListener('scroll', handleScroll);
        return (() => {
            document.removeEventListener('scroll', handleScroll);
        })
    }, [activeSlideNumber])

    const handleScroll = () => {
        const fixTopPiont = 240;
        const itinerarySlider = document.getElementById('itinerarySlider');
        const itinerarySliderBack = document.getElementById('itinerarySliderBack');
        const itinerarySliderContainer = document.getElementById('itinerarySliderContainer');
        const activeSlide = document.getElementById('activeSlide');
        const prevSlide = document.getElementById('prevSlide');
        const nextSlide = document.getElementById('nextSlide');
        const endTravel = document.getElementById('endTravel');
        const itinerarySliderRect = itinerarySlider?.getBoundingClientRect();
        const itinerarySliderContainerRect = itinerarySliderContainer?.getBoundingClientRect();
        const activeSlideRect = activeSlide?.getBoundingClientRect();
        const prevSlideRect = prevSlide?.getBoundingClientRect();
        const nextSlideRect = nextSlide?.getBoundingClientRect();
        const lastSlideIndex = +(activeSlide?.getAttribute('data-last-slide') || '-1');
        const sliderItems = document.getElementsByClassName('itinerary-slider-content-item') as HTMLCollectionOf<HTMLElement>;
        const sliderItemsTitle = document.getElementsByClassName('itinerary-slider-content-title') as HTMLCollectionOf<HTMLElement>;
        const nextSliderItems = document.getElementsByClassName('next-slide') as HTMLCollectionOf<HTMLElement>;

        if (itinerarySlider && itinerarySliderBack && itinerarySliderRect && itinerarySliderContainerRect) {
            if (itinerarySliderRect.top > 0 || itinerarySliderRect.bottom < window.innerHeight) {
                itinerarySliderBack.style.position = 'absolute';
                if (itinerarySliderRect.top > 0) {
                    itinerarySliderBack.style.top = '0px';
                    itinerarySliderBack.style.bottom = 'initial';
                    activeSlideIndex = 1;
                } else if (itinerarySliderContainerRect.height > window.innerHeight) {
                    itinerarySliderBack.style.top = 'initial';
                    itinerarySliderBack.style.bottom = '0px';
                    activeSlideIndex = sliderItems.length;
                }
                setActiveSlideNumber(activeSlideIndex);
            } else {
                itinerarySliderBack.style.position = 'fixed';
                endTravel?.style.setProperty('margin-top', `${window.innerHeight - (300 + sliderItems[sliderItems.length - 1].getBoundingClientRect().height)}px`);
            }

            if (activeSlideRect) {
                if (window.scrollY > scroll) {
                    if (!activeSlideHeight)
                        activeSlideHeight = activeSlideRect.height;
                    if (nextSlideRect && nextSlideRect.top <= fixTopPiont && activeSlideIndex < sliderItems.length) {
                        activeSlideHeight = nextSlideRect.height;
                        activeSlideIndex++;
                        setActiveSlideNumber(activeSlideIndex);
                    }
                    else if (lastSlideIndex === -1 && nextSlideRect && nextSlideRect.top < activeSlideRect.height + fixTopPiont && activeSlide) {
                        activeSlide.style.maxHeight = `${activeSlideRect.height - (window.scrollY - scroll) - 10}px`;
                    }
                    else if (lastSlideIndex !== -1 && sliderItemsTitle.length > 0 && activeSlideRect.top < fixTopPiont) {
                        const title = sliderItemsTitle[lastSlideIndex];
                        title.style.top = `${activeSlideRect.top - 160}px`;
                    } else {
                        for (const key in sliderItemsTitle) {
                            if (Object.prototype.hasOwnProperty.call(sliderItemsTitle, key)) {
                                const element = sliderItemsTitle[key];
                                element.style.top = '';
                            }
                        }
                    }
                } else {
                    if (prevSlide)
                        prevSlide.style.top = '';
                    if (prevSlideRect?.height && activeSlideRect.top >= fixTopPiont + prevSlideRect.height && activeSlideIndex > 0) {
                        const preSlideHeight = (prevSlide?.parentNode as HTMLElement).style.height;
                        activeSlideHeight = +preSlideHeight.replace('px', '');
                        activeSlideIndex--;
                        setActiveSlideNumber(activeSlideIndex);
                    }
                    else if (activeSlide && activeSlideRect.height < activeSlideHeight) {
                        activeSlide.style.maxHeight = `${activeSlideRect.height + (scroll - window.scrollY)}px`;
                    }
                    else if (lastSlideIndex !== -1 && sliderItemsTitle.length > 0) {
                        const title = sliderItemsTitle[lastSlideIndex];
                        if (activeSlideRect.top > 0 && activeSlideRect.top < fixTopPiont) {
                            title.style.top = `${activeSlideRect.top - 160}px`;
                        } else if (activeSlideRect.top >= fixTopPiont) {
                            title.style.top = '';
                        }
                    }
                    else if (activeSlide) {
                        activeSlide.style.maxHeight = ''
                    }

                    for (const key in nextSliderItems) {
                        if (Object.prototype.hasOwnProperty.call(nextSliderItems, key)) {
                            const element = nextSliderItems[key];
                            element.style.maxHeight = '';
                        }
                    }
                }
            }
        }
        scroll = window.scrollY;
    }

    return (
        <div className="upcoming-event">
            <div id="itinerarySlider" className="itinerary-slider">
                <div id="itinerarySliderBack" className="itinerary-slider-image" style={{ height: window.innerHeight }}>
                    {
                        content.images.map((image, index) =>
                            <div
                                key={`slider_image_item_${index}`}
                                className={`itinerary-slider-image-item${activeSlideNumber === index + 1 ? ' active-slide' : ''}`}
                            >
                                <OptimizedImage key={`slider_image_${index}`} source={image} />
                            </div>
                        )
                    }
                </div>
                <div id="itinerarySliderContent" className="itinerary-slider-content">
                    <div
                        id="itinerarySliderContainer"
                        className="container"
                    >
                        <div id="itinerarySliderSwipper" className="itinerary-slider-content-swipper" />
                        {
                            content.descriptions.map((description, index) =>
                                <div
                                    key={`itinerary_slider_content_${index}`}
                                    className="itinerary-slider-content-description"
                                >
                                    <div className="itinerary-slider-content-title">
                                        <Icon name={`icon-${season[seasonsOrder.findIndex(o => o === description.season)]?.toLowerCase()}-outline`} className="season-icon" />
                                        <span className="mf-2">{description.season}</span>
                                    </div>
                                    {
                                        description.events?.map((event, i) => {
                                            itemIndex++;

                                            return (
                                                <div
                                                    key={`slider_content_item_${itemIndex}`}
                                                    id={scrollIndex.current === itemIndex ? 'activeScroll' : ''}
                                                    className={`itinerary-slider-content-item ${itemIndex % 2 ? 'slider-item-right' : 'slider-item-left'}`}
                                                >
                                                    <div
                                                        id={itemIndex === activeSlideNumber ? 'activeSlide' : itemIndex === activeSlideNumber - 1 ? 'prevSlide' : itemIndex === activeSlideNumber + 1 ? 'nextSlide' : ''}
                                                        className={`itinerary-slider-content-item-container${activeSlideNumber === itemIndex ? ' active-slide' : itemIndex < activeSlideNumber ? ' prev-slide' : itemIndex > activeSlideNumber ? ` next-slide` : ''}`}
                                                        data-last-slide={i === (description.events?.length || 0) - 1 ? index : ''}
                                                        data-active-scroll={tr('next_event')}
                                                    >
                                                        <div className="itinerary-slider-content-item-time">
                                                            <span className="day-indicator">{new Date(event.startTime || 0).toLocaleDateString(code, { day: 'numeric' })}</span>
                                                            <span className="month-indicator">{new Date(event.startTime || 0).toLocaleDateString(code, { month: 'short' }).toUpperCase()}</span>
                                                        </div>
                                                        <div className="row itinerary-slider-content-item-data">
                                                            <div className="col-1-1 col-md-1-1 col-sm-1-1">
                                                                <div className="itinerary-slider-content-item-data-title">{event.displayText}</div>
                                                                <div>{event.description}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        }
                        <div id="endTravel" className="itinerary-slider-content-description" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpcomingEvent;